import { type DispatchListDetailExEntity } from '../..'

export type DispatchDetailFrameType = DispatchListDetailExEntity['frameType']

export const DISPATCH_DETAIL_FRAME_TYPE = {
  DELIVERY: 'DELIVERY',
  SCHEDULED: 'SCHEDULED',
  FREE_TIME: 'FREE_TIME'
} as const satisfies Record<DispatchDetailFrameType, DispatchDetailFrameType>
